// ProtectedRoute с тремя режимами:
//   mode='ready'                 — обычный shell: authed + пароль сменён + ПДн принято
//   mode='must-change-password'  — только страница смены пароля
//   mode='accept-pdn'            — только страница согласия на ПДн
//
// Редиректы между режимами:
//   guest                                → /login
//   authed + mustChangePassword=true     → /change-password
//   authed + !pdnAcceptedAt              → /accept-pdn
//   всё ОК                                → /  (или Outlet для ready)

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { useAuth } from './AuthContext.jsx';

function nextStepAfterAuth(user) {
    if (user.mustChangePassword) return '/change-password';
    if (!user.pdnAcceptedAt) return '/accept-pdn';
    return '/';
}

export function ProtectedRoute({ mode = 'ready' }) {
    const { status, user } = useAuth();
    const location = useLocation();

    if (status === 'loading') {
        return (
            <Center style={{ minHeight: '100vh' }}>
                <Loader size="md" />
            </Center>
        );
    }

    if (status !== 'authed') {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    if (mode === 'must-change-password') {
        if (!user.mustChangePassword) {
            // Пароль уже сменён — двигаем дальше по цепочке
            return <Navigate to={nextStepAfterAuth(user)} replace />;
        }
        return <Outlet />;
    }

    if (mode === 'accept-pdn') {
        // Сначала пароль, только потом ПДн
        if (user.mustChangePassword) return <Navigate to="/change-password" replace />;
        if (user.pdnAcceptedAt) return <Navigate to="/" replace />;
        return <Outlet />;
    }

    // mode === 'ready'
    if (user.mustChangePassword) return <Navigate to="/change-password" replace />;
    if (!user.pdnAcceptedAt) return <Navigate to="/accept-pdn" replace />;
    return <Outlet />;
}
